import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useCurrentPage(slug?: string) {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const page = Number.parseInt(searchParams.get(slug ? `${slug}-page` : 'page') ?? '', 10);
    return Number.isNaN(page) || page < 1 ? 1 : page;
  }, [searchParams, slug]);
}
